module.exports = __webpack_public_path__ + "img/icons_16.087c02c4.png";